/**
 * @file 校区管理页
 * @description 侧栏「校区管理」对应页面：子校区列表与行操作（本地 mock）。
 *
 * @whenToUse 路由 `/`。
 * @whenNotToUse 其他业务菜单页。
 */

import { CampusPanel } from '@/components/pages/campus-page/campus-panel.tsx'

export function CampusPage() {
  return <CampusPanel />
}
